import { render, staticRenderFns } from "./NavVerticalBorder.vue?vue&type=template&id=3f2e2054"
import script from "./NavVerticalBorder.vue?vue&type=script&lang=js"
export * from "./NavVerticalBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports